import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { KBQShoppersData } from 'components/KBQSelect'

const initialState: KBQShoppersData[] = []

const kbqChartDataSlices = createSlice({
  name: 'KBQChartData',
  initialState,
  reducers: {
    setKBQChartData(state, action: PayloadAction<KBQShoppersData>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})

export const { setKBQChartData } = kbqChartDataSlices.actions

export default kbqChartDataSlices.reducer
